class LicensePriceTiers {
  constructor(data) {
    this.price = data.p;
    this.numberOfMemberships = data.nom;
  }
}

export default LicensePriceTiers
